<template>
	<div class="single_content">
		<v-breadcrumbs id="breadcrumbs" class="back">
			<v-icon slot="divider">chevron_right</v-icon>
			<v-breadcrumbs-item>
				<router-link :to="{ name: 'projects'}" class="back"> {{ routeName }} </router-link>
			</v-breadcrumbs-item>
			<v-breadcrumbs-item>
				{{data.label}}
			</v-breadcrumbs-item>
		</v-breadcrumbs>

		<v-loading loader='setSingleData' class="loader" v-if="$loading.isLoading('setSingleData')">
            <template slot='spinner'>
                <div class="loader">
                    <img src="../../../assets/img/grid_loader.svg"/>
                </div>
            </template>
        </v-loading>

	   <div class="single"
	   		v-scroll="{target: '#scroll-target', callback: this.onScroll}"
			:class="{'fixed': scrollPosition > 90}"
			v-if="!$loading.isLoading('setSingleData')">

			<aside>
				<div class="top">
					<div class="border">
						<more-actions :actions="actions"></more-actions>
					</div>
				</div>

				<div class="contain">
					<div class="name">
						<h2>{{ data.label }}</h2>
						<p v-if="data.category">
							{{data.category.parent.parent.label}} - {{data.category.parent.label}} - {{data.category.label}}
						</p>
						<template v-if="data.status">
							<v-menu offset-y>
	                            <v-btn flat round color="primary" slot="activator">
	                            	{{ $_.find(ProjectStatuses, s => s.value == data.status).label }}
									<v-icon>arrow_drop_down</v-icon>
	                            </v-btn>
	                            <v-list>
									<v-list-tile v-for="(status,index) in ProjectStatuses" :key="index" @click="updateStatus(status.value)" class="li">
	                                    <v-list-tile-title>{{ status.label }}</v-list-tile-title>
	                                </v-list-tile>
	                            </v-list>
	                        </v-menu>
						</template>
					</div>

					<div class="numbers">
						<div @click.stop="$router.push({ name: 'project-products-competitors' })">
							<span>{{data.competitor_products_count}}</span> {{data.competitor_products_count | pluralize('Produit')}} {{data.competitor_products_count | pluralize('Concurrent')}}
						</div>
						<div @click.stop="$router.push({ name: 'project-products-suppliers' })">
							<span>{{data.supplier_products_count}}</span> {{data.supplier_products_count | pluralize('Produit')}} {{data.supplier_products_count | pluralize('Fournisseur')}}
						</div>
					</div>

					<div class="about">
						<div class="field mb-1" data-group="0" v-if="data.sidamo_product">
							<div class="label">Produit Sidamo</div>
							<div class="value" v-if="data.sidamo_product">
								<router-link :to="{ name: 'single-product', params: { super_family: data.category.parent.parent.label, id: data.sidamo_product.id }}">
									{{data.sidamo_product.label}}
								</router-link>
							</div>
						</div>

						<div class="field mb-1" data-group="0">
							<div class="label">Date de modif.</div>
							<div class="value">
								{{moment(data.updated_at).format('DD/MM/YYYY')}}
							</div>
						</div>

						<div class="field mb-1" data-group="0">
							<div class="label">Date de créa.</div>
							<div class="value">
								{{moment(data.created_at).format('DD/MM/YYYY')}}
							</div>
						</div>

						<div class="field mb-1" data-group="0">
							<div class="label">Gestionnaire</div>
							<div class="value">
								<template v-if="data.user">
									<avatar :item="data.user"></avatar>
									{{data.user ? data.user.first_name : ''}} {{data.user ? data.user.last_name :''}}
								</template>
								<v-btn icon small @click="$eventHub.$emit('open-modal', UpdateManager)" class="edit" :disabled="$store.state.auth.user.level < 60"><v-icon>mode_edit</v-icon></v-btn>
							</div>
						</div>
					</div>
				</div>
			</aside>

			<div class="tab">
				<v-tabs slider-color="primary" :show-arrows="true">
					<v-tab ripple :to="{ name: 'project-products-suppliers' }">
						{{data.supplier_products_count | pluralize('Produit fournisseur','Produits fournisseurs')}}
						({{data.supplier_products_count}})
					</v-tab>
					<v-tab ripple :to="{ name: 'project-products-competitors' }">
						{{data.competitor_products_count | pluralize('Produit concurrent', 'Produits concurrents')}}
						({{data.competitor_products_count}})
					</v-tab>
					<v-tab ripple :to="{ name: 'project-products-sidamos' }">
						{{data.sidamo_products_count | pluralize('Produit sidamo', 'Produits sidamos')}}
						({{data.sidamo_products_count}})
					</v-tab>
					<v-tab ripple :to="{ name: 'project-files' }">
						{{data.files_count | pluralize('Fichier')}} ({{data.files_count}})
					</v-tab>
				</v-tabs>

				<div class="router_view">
					<router-view />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import projectStatus from '../../../filters/projectStatus.js'
import pluralize from '../../../filters/pluralize.js'
import Avatar from '../../../components/avatar/Avatar.vue'
import MultiAvatar from '../../../components/avatar/MultiAvatar.vue'
import SingleField from '../../../components/SingleField.vue'
import {ProjectStatuses} from '../../../config/enum/ProjectStatuses'
import Delete from './Delete.vue'
import UpdateManager from './UpdateManager.vue'
import ConvertProject from './ConvertProject.vue'
import MoreActions			from '../../../components/single/MoreActions'
import moment from 'moment'

export default {
	components: { Avatar, SingleField, MultiAvatar, MoreActions },

	data() {
		return {
		    moment,
			ProjectStatuses,
			project: {},
			scrollPosition: '',
			Delete,
			UpdateManager,
			actions: [
				{ text: 'Exporter les produits fournisseurs', 	callback: () => this.exportProducts('supplier') },
				{ text: 'Exporter les produits concurrents', 	callback: () => this.exportProducts('competitor') },
				{ text: 'Supprimer',	callback: () => this.$eventHub.$emit('open-modal', Delete), level: 60 }
			],

			showStatus: false,
            menuStatus:	false
		}
	},

	computed: {
		data() {
			return this.$store.state.single.data
		},
		routeName() {
			let name = this.$route.path.split('/')
			return name[1]
		}
	},

	methods: {
		updateField(key, value, resource = 'projects') {
			let model = {};
			model[key] = value;

			this.axios.put(`/api/${resource}/${this.$route.params.id}`, model)
				.then(response => {
					this.$store.dispatch('updateSingleData', { key, value })
				})
				.catch(error => {
					this.$refs[key].setError(error.response.data.errors[key][0])
				})
		},

		updateMeta(meta, value) {
			let model = { metas: [] }

			if (meta.options != undefined) {
				if (typeof value == 'number') {
					model.metas.push({ meta_id: meta.id, meta_value_id: [value] })
				} else {
					model.metas.push({ meta_id: meta.id, meta_value_id: value })
				}

			} else {
				model.metas.push({ meta_id: meta.id, value: value })
			}

			this.axios.put(`/api/projects/${this.$route.params.id}`, model)
				.then(response => {
					this.$store.dispatch('updateSingleMetaData', { meta, value })
				})
				.catch(error => {
					this.$refs[meta.slug].setError(error.response.data.errors[meta.slug][0])
				})
		},

		updateStatus(value) {
            this.axios.put(`/api/projects/${this.$route.params.id}`, { status: value })
                .then(res 	=> this.$store.dispatch('updateSingleData', { key: 'status', value: value }))
                .catch(err	=> console.log(err))
        },

		getDataFromApi(load = true) {
			load == false ? '' : this.$loading.startLoading('setSingleData')
			this.axios.get(`/api/projects/${this.$route.params.id}?embed=user,sidamo_products.category.parent,sidamo_products.fields,competitor_products.comments.user,supplier_products.comments.user,competitor_products.category.parent.parent,competitor_products.supplier,supplier_products.category.parent.parent,supplier_products.supplier,category.parent.parent,supplier_products.fields,competitor_products.fields,files`)
				.then(response => {
					this.project = response.data
					this.$store.dispatch('setSingleData', { data: this.project })
					if(this.project.supplier_products_count > 0){
						let index = this.actions.findIndex(a => a.text == 'Convertir')
						if(index == -1) {
							this.actions.push({ text: 'Convertir',	callback: () => this.$eventHub.$emit('open-modal', ConvertProject), level: 60 })
						}
					}
					this.$loading.endLoading('setSingleData')
				})

		},

		onScroll(e) {
			this.scrollPosition = e.target.scrollTop
		},

		exportProducts(type) {
			this.axios.post(`/api/projects/${this.$route.params.id}/export`, { type })
				.then(res => {
					let a 	= document.createElement('A')
					a.href	= res.data
					document.body.appendChild(a)
					a.click()
					document.body.removeChild(a)
				})
		}
	},

	watch: {
		$route(to, from) {
			this.getDataFromApi(false)
		}
	},

	created() {
		this.$eventHub.$on('reload-single-project', () => {
			this.getDataFromApi(false)
		});
	},

	mounted() {
		this.getDataFromApi()
	}
}
</script>

<style lang="stylus" scoped>
    @require '../../../assets/css/main.styl'

    aside {
      	position:relative

    	div.numbers {
        	div {
            	&:nth-of-type(-n+2) {
                	border-right: 1px solid $border-light-color
            	}
        	}
    	}

    	div.about {
        	flex-grow: 1

        	.avatar {
          		margin-right:10px
        	}
    	}

        div.single-actions {
            padding: 6px
        }
	}
</style>



// WEBPACK FOOTER //
// src/views/projects/single/Single.vue